export const pulse = {
  name: "pulse" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M7.017 7.6a.9.9 0 0 1 .823.577l1.876 4.877L10.75 11.5a.9.9 0 0 1 .749-.401H20a.9.9 0 1 1 0 1.8h-8.018l-1.733 2.6a.9.9 0 0 1-1.589-.177L6.955 10.89l-.628 1.464a.9.9 0 0 1-.827.546h-2a.9.9 0 0 1 0-1.8h1.407l1.266-2.955a.9.9 0 0 1 .844-.545Z" clip-rule="evenodd"/></svg>`,
  keywords: ["pulse"],
  category: "other" as const,
};
